/*
 * @Description:
 * @Author: sam.xutao
 * @Date: 2020-02-20 11:00:58
 * @LastEditTime: 2020-04-02 11:38:55
 * @LastEditors: sam.xutao
 */
/***********************
 * @name JS
 * @author Jo.gel
 * @date 2019/3/20 0020
 ***********************/
import axios from 'axios';
import { mobileModel } from 'mobile-device-detect';
import VueCookies from 'vue-cookies'
import {getSource} from './tool';
// axios.defaults.baseUrl = 'http://10.71.18.95/';
const axiosIns = axios.create({
	baseURL:'https://vipapi.app.cctv.com',
	// baseURL: 'http://10.51.28.5:8081/',
});
// req 拦截器
axiosIns.interceptors.request.use(req => {
	if (!req.url) {
		console.info('请检查，url为空：' + req.url);
	}
	// req.url = 'https://vipapi.app.cctv.com'+req.url ;
    if(req.method == 'post'){
		if(VueCookies.get("verifycode")){
			req.headers.verifycode = VueCookies.get("verifycode");
		}
		if(VueCookies.get("userSeqId")){
			req.data.params.uid = VueCookies.get("userSeqId");
		}
		req.headers.deviceNo = '123';
		req.data.params.modelName = mobileModel;
		req.data.params.source = getSource();
		req.data.params.productId = 'sdfs343';
        req.data.header = localStorage.getItem("header") && localStorage.getItem("header") !== 'undefined' ? JSON.parse(localStorage.getItem("header")) : '';
        req.data.token = localStorage.getItem("token") && localStorage.getItem("token") !== 'undefined' ? localStorage.getItem("token") : '';
    }
	return req;
}, err => {
	return Promise.reject(err.request);
});

// res 拦截器
axiosIns.interceptors.response.use(res => {
	if (res && res.data) {
		return Promise.resolve(res.data);
	}
	return res.data;
}, err => {
	return Promise.resolve(err.response);
});


export const axios_get = async (url, data = {},  headers,msg = '接口异常',) => {
	return axiosIns.get(url, {params: data, ...headers})
		.then(res => {
			let iRes = res && res.config ? res.data : res;
			if ((iRes && iRes.code === 10000) || iRes.code === '10000') {
                return Promise.resolve(iRes || {});
			} 
			else if (iRes.code === 20004) {
				return Promise.reject(iRes || {});
			} 
			else {
				return Promise.resolve(iRes || {});
			}
		})
		.catch(err => {
			console.info(err.message || msg);
		});
};
export const axios_post = async (url, data = {}, headers,msg = '接口异常') => {
    data = {params:data};
	return axiosIns.post(url, data, {...headers}).then(res => {
		let iRes = res && res.config ? res.data : res;
		if ((iRes && iRes.code === 10000) || iRes.code === '10000') {
			return Promise.resolve(iRes);
		} else if (iRes.code === 20004) {
			return Promise.reject(iRes);
		} else if(iRes.code === 20000){
			window.location.href = "//m.cctv.com/mobile/kjdl/index.shtml?service=" + encodeURIComponent(window.location.href+"&other=");
		}else {
			return Promise.resolve(iRes);
		}
	}).catch(err => {
		console.info(err.message || msg);
	});
};
